// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"2328ebba","202":"2935458f","305":"0c9e6753","427":"9543b278","432":"71bab739","643":"8f1c4e26","644":"6d4039a9","701":"d445191c","826":"99652b35","853":"66368a9e","881":"5a58ffca","899":"0e3557b9","972":"98f417ab"}[chunkId] + ".chunk.js";
};